import React from 'react';

import { getCurrentPage } from '../helpers';

import '@awesome.me/webawesome/dist/components/pagination/pagination.js';

interface PaginationProps {
  total: number;
  perPage?: number;
};

const Pagination: React.FC<PaginationProps> = ({ total, perPage = 12 }) => {
  if (total < perPage) {
    return null;
  }

  return (
    <div className="pagination-container">
      <wa-pagination total={total} page-size={perPage} page={getCurrentPage()} href-template="?page={page}"></wa-pagination>
    </div>
  );
}

export default Pagination;
